import { Outlet } from 'react-router-dom';

export const healthRoute = [
  {
    path: 'health',
    element: <Outlet />,
    children: [{ element: <div>Ok!</div>, index: true }],
  },
];
